import { Container, Panel, Sidenav, Content, Dropdown, Breadcrumb, IconButton, Avatar } from "rsuite"
import GearCircleIcon from '@rsuite/icons/legacy/GearCircle';
import NoticeIcon from '@rsuite/icons/Notice';

import { forwardRef } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";

import PageHeaderUserAvatar from "./pageHeaderUserAvatar";
import PageHeaderUserNotifications from "./pageHeaderUserNotifications";

export default function Header({pageName, expand, setExpand}) {
    const { panel, key } = useParams();

    const panelToPagename = {
        "admin": "Менеджмент",
        "reports": "Отчётность",

    }

    const NavLink = forwardRef(({ href, children, ...rest }, ref) => (
        <Link ref={ref} to={href} {...rest}>
          {children}
        </Link>
      ));

    return (
        <div className="page-header">
            <div className="page-header-with_brand">
                <span className={"page-header-brand" + (expand ? " collapsed" : "")}>АЛТИОРА</span>
                <div style={{display: "flex", flexDirection: "column", alignItems: "start", justifyContent: "center"}}>
                    {panelToPagename[panel] ? panelToPagename[panel] : "Брифы"}
                </div>
            </div>
            <div className="page-options">
                <PageHeaderUserNotifications />
                <PageHeaderUserAvatar />
            </div>
        </div>
    )
}